import React from 'react';
import { TimeSelectPropsWithFormControl } from './types';
import { FilterableSelect } from '../FilterableSelect/FilterableSelect';
import { useTimeInputMask } from '@gettactic/helpers/src/input/useTimeInputMask';
import { generateStringTimeItems } from '@gettactic/helpers/src/date-time/generateStringTimeItems';
import { isValidTime } from '@gettactic/helpers/src/date-time/isValidTime';
import { TIME_SELECT_INTERVAL_MINUTES } from '@v2/components/time/constants';

export const TimeSelect = React.forwardRef<
  HTMLInputElement,
  TimeSelectPropsWithFormControl
>((props, ref) => {
  const { interval = TIME_SELECT_INTERVAL_MINUTES, ...rest } = props;
  const timeMask = useTimeInputMask();

  const timeItems = React.useMemo(() => {
    let foundValueTime = false;
    const values = generateStringTimeItems(interval, true).map((time) => {
      if(time === rest.value){
        foundValueTime = true;
      }
      return {
      value: time,
      label: time
    }});

    if(!foundValueTime && rest.value) {
        values.unshift({
            value: rest.value,
            label: rest.value
        });
    }

    return values;
  }, [interval, rest.value]);

  return (
    <FilterableSelect
      items={timeItems}
      validateCustomValue={(value) => isValidTime(value, true)}
      mask={timeMask}
      allowCustomValue
      {...rest}
    />
  );
});

TimeSelect.displayName = 'TimeSelect';
